module.exports = "<cian-af-about-building-ceiling-height ad=\"ceilingHeight.ad\" form=\"ceilingHeight.form\"></cian-af-about-building-ceiling-height>"